<template>
  <div id="password-change-wrapper">
    {{$route.params.userid}}
    <h2 class="my-page-header">パスワードの変更</h2>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form id="password-change-form" @submit.prevent="handleSubmit(onSubmit)">
        <div class="password-change-field">
          <label class="p-form-title" for="current-password">現在のパスワード</label>
          <div class="input-wrapper">
            <ValidatedInput type="password" vid="current-password" name="パスワード" v-model="form.currentPassword" id="current-password" rules="required" class="inner-input-wrapper"/>
          </div>
        </div>
        <div class="password-change-field">
          <label class="p-form-title" for="change-password">新しいパスワード</label>
          <div class="input-wrapper">
            <ValidatedInput placeholder="半角英数字8文字以上" vid="change-password" type="password" name="パスワード" v-model="form.password" id="change-password" rules="required|passwordIsNew:@current-password" class="inner-input-wrapper"/>
          </div>
        </div>
        <div class="password-change-field">
          <label class="p-form-title" for="password-confirm">新しいパスワード(確認)</label>
          <div class="input-wrapper">
            <ValidatedInput type="password" name="パスワード" v-model="form.passwordConfirm" id="password-confirm" rules="required|confirmed:change-password" class="inner-input-wrapper" />
          </div>
        </div>
        <p v-if="err.isErr" class="p-errmsg">
          <span>
            <img src="@/assets/attention.png" alt="エラー" width="22" height="22" />
          </span>
          {{ err.msg }}
        </p>
        <input
          v-if="submitting"
          disabled
          type="submit"
          name="パスワード変更"
          value="変更中です。。"
          class="submit-button disabled-button round-button"
          />
        <input
          v-else
          type="submit"
          name="パスワード変更"
          value="変更する"
          class="submit-button round-button"
          />
        <!-- <input
          name="退会"
          @click="onWithdrawSubmit"
          value="退会する(テスト用)"
          class="submit-button round-button"
          /> -->
      </form>
    </ValidationObserver>
    <ConfirmationModal @close="modal = false" @submit="finish" :modal="modal" header="パスワード変更">
      パスワードを変更してもよろしいでしょうか？
    </ConfirmationModal>
    <!-- <ConfirmationModal @close="taikaiModal = false" @submit="finishWithdraw" :modal="taikaiModal" header="退会">
      退会してよろしいですか？
    </ConfirmationModal> -->
  </div>

</template>

<script>
import { updatePassword } from '@/utils/auth';
import ValidatedInput from '@/components/common/validation/ValidatedInput';
import ConfirmationModal from '@/components/common/ConfirmationModal';
import { ValidationObserver } from 'vee-validate';

export default {
  name: 'MypageModifyProfileMobile',
  components: { ValidationObserver, ValidatedInput, ConfirmationModal },
  data() {
    return {
      err: {
        isErr: false,
        msg: '',
      },
      modal: false,
      taikaiModal: false,
      submitting: false,
      form: {},
    };
  },
  methods: {
    onSubmit() {
      if (this.submitting) {
        return;
      }
      this.modal = true;
    },
    // onWithdrawSubmit() {
    //   if (this.submitting) {
    //     return;
    //   }
    //   this.taikaiModal = true;
    // },
    async finish() {
      if (this.submitting) {
        return;
      }
      this.modal = false;
      this.err.isErr = false;
      this.err.msg = '';
      try {
        this.submitting = true;
        await updatePassword(this.$store.state.user.email, this.form.currentPassword, this.form.password);
        this.navigateComplete();
      } catch (e) {
        this.err.isErr = true;
        this.handleError(e);
      } finally {
        this.submitting = false;
      }
    },
    // async finishWithdraw() {
    //   if (this.submitting) {
    //     return;
    //   }
    //   this.taikaiModal = false;
    //   this.err.isErr = false;
    //   this.err.msg = '';
    //   try {
    //     this.submitting = true;
    //     await withdraw(this.$store.state.user.sub);
    //     signOut();
    //   } catch (e) {
    //     this.err.isErr = true;
    //     this.handleError(e);
    //   } finally {
    //     this.submitting = false;
    //   }
    // },
    navigateComplete() {
      this.$emit('updated', 'password-complete');
    },
    handleError(e) {
      if (e.code === 'InvalidParameterException') {
        this.err.msg = '正しい形式のパスワードを入力してください';
      } else if (e.code === 'NotAuthorizedException') {
        this.err.msg = '現在の正しいパスワードを入力してください。';
      } else {
        this.err.msg = 'エラーが発生しました。';
      }
    },
  },
};
</script>
<style scoped lang="scss">
@charset "UTF-8";
@import "../../assets/style/parts_responsive.scss";

.c-autologin {
  font-size: 14px;
  text-align: center;
}

.p-formchart {
  li:nth-child(1) {
    background: #f79;
    color: white;
    border: 0;
  }
}

#password-change-form {
  padding: 20px 0;

  .inner-input-wrapper {
    width: 100%;
  }

  .password-change-field {
    padding: 12px 0;
    font-size: 16px;
    display: flex;
    flex-wrap: wrap;
    input {
      width: 100%;
      margin-top: 8px;
      margin-top: 0px;
      height: 32px;
    }
    label {
      width: 100%;
      height: 24px;
      font-size: 16px;
      span {
        &.required {
          margin-left: 1em;
          padding: 0px 6px 0px 6px;
          font-size: 10px;
          color: white;
          background-color: #c44;
        }
        &.optional {
          margin-left: 1em;
          padding: 0px 6px 0px 6px;
          font-size: 10px;
          color: white;
          background-color: #aaaaaa;
        }
      }
    }
  }
}

.p-paragraph--small {
  text-align: center;
}

.p-h2 {
  padding-left: 0;
  padding-right: 0;
  text-align: left;
  margin:0;
  line-height: 1em;
}

.input-wrapper {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

@media (min-width: 640px) {
  #password-change-wrapper {
    background-color: white;
    padding: 30px 40px;
    border: 1px solid #CCCCCC;
    border-radius: 14px;
    margin: 14px;
    margin-bottom: 100px;
  }

  .input-wrapper {
    width: 64%;
    input {
      width: 100%;
    }
  }

  #password-change-form {
    .password-change-field {
      align-items: center;

      input {
        width: 70%
      }
      label {
        padding-right: 8px;
        height: 100%;
        width: 30%;
        text-align: right;
      }
    }
  }
}


</style>
